/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To hit 15,000 × g on an 8 cm rotor you need about 12,950 RPM.`)
};

const es_gf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para alcanzar 15.000 × g en un rotor de 8 cm necesitas unas 12.950 RPM.`)
};

const de_gf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für 15.000 × g bei einem 8-cm-Rotor benötigen Sie etwa 12.950 RPM.`)
};

const nl_gf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om 15.000 × g te bereiken op een rotor van 8 cm heeft u ongeveer 12.950 RPM nodig.`)
};

const fr_gf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour atteindre 15 000 × g sur un rotor de 8 cm, il faut environ 12 950 RPM.`)
};

const it_gf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per raggiungere 15.000 × g su un rotore da 8 cm servono circa 12.950 RPM.`)
};

const pt_br2_gf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para atingir 15.000 × g em um rotor de 8 cm, você precisa de cerca de 12.950 RPM.`)
};

const pt_gf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para atingir 15 000 × g num rotor de 8 cm são necessárias cerca de 12 950 RPM.`)
};

const ja_gf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`半径8cmのローターで15,000 × gを得るには、約12,950 RPMが必要です。`)
};

const zh_gf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 8 cm 转子上要达到 15,000 × g，需要约 12,950 RPM。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_ex2", locale)
	if (locale === "en") return en_gf_ex2(inputs)
	if (locale === "es") return es_gf_ex2(inputs)
	if (locale === "de") return de_gf_ex2(inputs)
	if (locale === "nl") return nl_gf_ex2(inputs)
	if (locale === "fr") return fr_gf_ex2(inputs)
	if (locale === "it") return it_gf_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_gf_ex2(inputs)
	if (locale === "pt") return pt_gf_ex2(inputs)
	if (locale === "ja") return ja_gf_ex2(inputs)
	return zh_gf_ex2(inputs)
};